import React from 'react';
import { AccountCircle, Business, AccountBox } from '@material-ui/icons';

import { findMainOrganizationRole } from 'utils/user';
import Fields from 'ui/form/FieldsForm';
import PaperForm from 'ui/form/PaperForm';
import ButtonsForm from 'ui/form/ButtonsForm';
import SectionForm from 'ui/form/SectionForm';

import BusinessPart from '../parts/BusinessPart';
import TeamPart from '../parts/TeamPart';
import { isCustomerType, ORGANIZATION_TYPES } from '../consts';

const getAccountTypesOptions = (user, types = ORGANIZATION_TYPES) => {
    const role = findMainOrganizationRole(user);
    return types[role] || {};
};

export default function CompanyDetailStep({
    onChange,
    goNext,
    goBack,
    errors,
    values,
    extra,
}) {
    const onChangeType = type => {
        if (type !== values.type) {
            onChange({
                createPartnerAccount: !isCustomerType(type),
                type,
            });
        }
    };
    const accountTypesOptions = getAccountTypesOptions(extra.user);
    if (!values.type) {
        onChangeType(Object.keys(accountTypesOptions)[0]);
    }
    return (
        <PaperForm title="Company Details">
            <SectionForm icon={AccountCircle}>
                <Fields.Select
                    label="Account type"
                    value={values.type}
                    error={errors.type}
                    disabled={!extra.creating}
                    onChange={onChangeType}
                    options={accountTypesOptions}
                />
            </SectionForm>
            <SectionForm icon={Business}>
                <BusinessPart
                    values={values}
                    errors={errors}
                    onChange={onChange}
                />
            </SectionForm>
            <SectionForm icon={AccountBox}>
                <TeamPart values={values} errors={errors} onChange={onChange} />
            </SectionForm>
            <ButtonsForm>
                <ButtonsForm.BackButton label="Cancel" onClick={goBack} />
                <ButtonsForm.NextButton onClick={goNext} />
            </ButtonsForm>
        </PaperForm>
    );
}
